import { TwoColumnBox } from "Components/TwoColumnBox";
import { WorkPermit } from "./WorkPermit";
import { GeoGraphicalPreference } from "./GeographicalPreference";
import { AreasOfHelp } from "./AreasOfHelp";
import { useState } from "react";
import { Form } from "antd";
import { PhoneNumber } from "./PhoneNumber";
import { TuitionFeePreference } from "./TuitionFeePreference";

export const OtherPreferences = ({ form }) => {
  const [state, setState] = useState({
    workPermit: form.getFieldValue("workPermit"),
    geoGraphicalPreference: form.getFieldValue("geoGraphicalPreference"),
    selectedOptions: form.getFieldValue("selectedOptions") || [],
    phoneNumber: form.getFieldValue("phoneNumber"),
    tuitionFeePreference:
      form.getFieldValue("tuitionFeePreference") || "Out of State",
  });
  return (
    <TwoColumnBox
      leftElement={
        <>
          <Form.Item
            name="workPermit"
            rules={[{ required: true, message: "Please select a work permit" }]}
          >
            <WorkPermit
              selectedCard={state.workPermit}
              setSelectedCard={(value) => {
                setState((prev) => {
                  return { ...prev, workPermit: value };
                });
                form.setFieldsValue({ workPermit: value });
              }}
            />
          </Form.Item>
          <Form.Item
            name="geoGraphicalPreference"
            rules={[
              {
                required: true,
                message: "Please select a geographical preference",
              },
            ]}
          >
            <GeoGraphicalPreference
              selectedCard={state.geoGraphicalPreference}
              setSelectedCard={(value) => {
                setState((prev) => {
                  return { ...prev, geoGraphicalPreference: value };
                });
                form.setFieldsValue({ geoGraphicalPreference: value });
              }}
            />
          </Form.Item>
          {form.getFieldsValue("country") === "United States" && (
            <Form.Item name="tuitionFeePreference">
              <TuitionFeePreference
                selectedCard={state.tuitionFeePreference}
                setSelectedCard={(value) => {
                  setState((prev) => {
                    return { ...prev, tuitionFeePreference: value };
                  });
                  form.setFieldsValue({ tuitionFeePreference: value });
                }}
              />
            </Form.Item>
          )}
        </>
      }
      rightElement={
        <>
          <Form.Item
            name="selectedOptions"
            rules={[
              {
                required: true,
                message: "Please select at least one area of help",
              },
            ]}
          >
            <AreasOfHelp
              selectedOptions={state.selectedOptions}
              setSelectedOptions={(value) => {
                setState((prev) => {
                  return { ...prev, selectedOptions: value };
                });
                form.setFieldsValue({ selectedOptions: value });
              }}
            />
          </Form.Item>
          <Form.Item name="phoneNumber">
            <PhoneNumber
              phoneNumber={state.phoneNumber}
              setPhoneNumber={(value) => {
                setState((prev) => {
                  return { ...prev, phoneNumber: value };
                });
                form.setFieldsValue({ phoneNumber: value });
              }}
            />
          </Form.Item>
        </>
      }
    />
  );
};
